exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message_error[data-v-272cb371] {\n  color: red;\n  margin-top: 6px;\n}\n", ""]);

// exports
